import Instense from "./Axios-config";
import {
  IRevenueEntryRequest,
  IRevenuePostRequest,
} from "../Contracts/IRevenueEntryRequest ";
import { IStatisticsEntryRequest, IStatisticsPostRequest } from "../Contracts/IStatisticsEntryRequest";
import { ISegmentationEntryRequest } from "../Contracts/ISegmentationEntryRequest";
export class DailyActivityService {
  public static async getStartAuditDateNew(
    hid: number,
    date: string
  ): Promise<any | null> {
    const storage = JSON.parse(localStorage.getItem("storage")!);
    const tenantId = storage === null ? 0 : (storage.tenantID as any);
    const response = await Instense.get<any | null>(
      `/DailyActivity/GetStartAuditDateNew`,
      {
        params: { hid, date, tenantId },
      }
    );
    return response.data;
  }

  public static async getDailyEntryRevenueDataBasedOnType(
    hid: number,
    date: string,
    typeId: number
  ): Promise<any[] | null> {
    const storage = JSON.parse(localStorage.getItem("storage")!);
    const tenantId = storage === null ? 0 : (storage.tenantID as any);

    const response = await Instense.get<any[]>(
      `/DailyActivity/GetDailyEntryRevenueDataBasedOnType`,
      {
        params: { hid, date, typeId, tenantId },
      }
    );
    return response.data;
  }

  public static async getDailyTransactions(
    hid: number,
    date: string
  ): Promise<any[] | null> {
    const storage = JSON.parse(localStorage.getItem("storage")!);
    const tenantId = storage?.tenantID || "";

    const response = await Instense.get<any[]>(
      "/DailyActivity/GetDailyTransactions",
      {
        params: { hid, date, tenantId },
      }
    );
    return response.data;
  }

  public static async saveRevenueEntry(
    data: IRevenuePostRequest
  ): Promise<any | null> {
    const storage = JSON.parse(localStorage.getItem("storage")!);
    const tenantId = storage?.tenantID || 0;
    const userName = storage?.userName || "";
    const requests = data.requests.map((entry) => ({
      ...entry,
      TenantID: tenantId,
      UserName: userName,
    }));
    data.requests = requests;
    const response = await Instense.post(
      `/DailyActivity/InsertRevenueEntry`,
      data
    );
    return response.data;
  }

  public static async GetStatisticsData(
    hid: number,
    date: string
  ): Promise<any[] | null> {
    const storage = JSON.parse(localStorage.getItem("storage")!);
    const tenantId = storage === null ? 0 : (storage.tenantID as any);

    const response = await Instense.get<any[]>(
      `/DailyActivity/GetStatisticsData`,
      {
        params: { hid, date, tenantId },
      }
    );
    return response.data;
  }

  public static async getRateCodeData(
    hid: number,
    date: string
  ): Promise<any[] | null> {
    const storage = JSON.parse(localStorage.getItem("storage")!);
    const tenantId = storage === null ? 0 : (storage.tenantID as any);

    const response = await Instense.get<any[]>(
      `/DailyActivity/GetRateCode`,
      {
        params: { hid, date, tenantId },
      }
    );
    return response.data;
  }

  public static async getRateCodeSummaryData(
    hid: number,
    date: string
  ): Promise<any[] | null> {
    const storage = JSON.parse(localStorage.getItem("storage")!);
    const tenantId = storage === null ? 0 : (storage.tenantID as any);

    const response = await Instense.get<any[]>(
      `/DailyActivity/GetSourceofSegment`,
      {
        params: { hid, date, tenantId },
      }
    );
    return response.data;
  }

  public static async saveSegmentationData(
    data: ISegmentationEntryRequest[]
  ): Promise<any | null> {
    const storage = JSON.parse(localStorage.getItem("storage")!);
    const tenantId = storage?.tenantID || 0;
    const userName = storage?.userName || "";
    const payload = data.map((entry) => ({
      ...entry,
      TenantID: tenantId,
      UserName: userName,
    }));
    const response = await Instense.post(
      `/DailyActivity/InsertSegmentationEntry`,
      payload
    );
    return response.data;
  }

  public static async getRoomRevenueTotal(
    hid: number,
    date: string
  ): Promise<any[] | null> {
    const storage = JSON.parse(localStorage.getItem("storage")!);
    const tenantId = storage === null ? 0 : (storage.tenantID as any);

    const response = await Instense.get<any[]>(
      `/DailyActivity/GetRoomRevenueTotal`,
      {
        params: { hid, date, tenantId },
      }
    );
    return response.data;
  }

  public static async GetTaxAuditTransactions(
    hid: number,
    date: string
  ): Promise<any[] | null> {
    const storage = JSON.parse(localStorage.getItem("storage")!);
    const tenantId = storage === null ? 0 : (storage.tenantID as any);

    const response = await Instense.get<any[]>(
      `/DailyActivity/GetDailyGet_TaxAuditTransactions`,
      {
        params: { hid, date, tenantId },
      }
    );
    return response.data;
  }
  
  public static async GetTaxAuditDetails(hid: number, date: string, AuditID: string): Promise < any[] | null > {
    const storage = JSON.parse(localStorage.getItem("storage")!);
    const tenantID = storage === null ? 0 : (storage.tenantID as any);
    const response = await Instense.get<any[]>(`/DailyActivity/GetTaxAuditDetails`, { params: { hid, date, AuditID, tenantID }, });
    return response.data;
  }


  public static async SaveStatisticsDetails(
    data: IStatisticsPostRequest
  ): Promise<any | null> {
    const storage = JSON.parse(localStorage.getItem("storage")!);
    const tenantId = storage?.tenantID || 0;
    const userName = storage?.userName || "";
    const requests = data.requests.map((entry) => ({
      ...entry,
      TenantID: tenantId,
      LoginUser: userName,
    }));
    data.requests = requests;
    const response = await Instense.post(
      `/DailyActivity/InsertStatisticsDetails`,
      data
    );
    return response.data;
  }
  public static async isExitsLabourHouseKepping(
    date: string,
    hid: number
  ): Promise<any | null> {
    const storage = JSON.parse(localStorage.getItem("storage")!);
    const tenantId = storage === null ? 0 : (storage.tenantID as any);
    const response = await Instense.get<any | null>(
      `/DailyActivity/IsExitsLabourHouseKepping`,
      {
        params: {  date,hid, tenantId },
      }
    );
    return response.data;
  }

  public static async CheckAccountingPeriod(
    entryDate: string,
    hid: number,
    module: string,
    isFromStatistics: boolean
  ): Promise<any | null> {
    const storage = JSON.parse(localStorage.getItem("storage")!);
    const tenantId = storage === null ? 0 : (storage.tenantID as any);
    const roleId = storage === null ? 0 : (storage.rolId as any);
    const response = await Instense.get<any | null>(
      `/DailyActivity/CheckAccountingPeriod`,
      {
        params: { entryDate, hid, module, tenantId, roleId, isFromStatistics },
      }
    );
    return response.data;
  }
  public static async GetDADepositAudit(
    hid: number,
    date: string
  ): Promise<any[] | null> {
    const storage = JSON.parse(localStorage.getItem("storage")!);
    const tenantId = storage === null ? 0 : (storage.tenantID as any);

    const response = await Instense.get<any[]>(
      `/DailyActivity/GetDADepositAudit`,
      {
        params: { hid, date, tenantId },
      }
    );
    return response.data;
  }

  public static async GetDADepositAuditDetails(
    hid: number,
    date: string,
    auditID: number
  ): Promise<any[] | null> {
    const storage = JSON.parse(localStorage.getItem("storage")!);
    const tenantId = storage === null ? 0 : (storage.tenantID as any);

    const response = await Instense.get<any[]>(
      `/DailyActivity/GetDADepositAuditDetails`,
      {
        params: { hid, date, tenantId, auditID },
      }
    );
    return response.data;
  }

  public static async GetDAChartList(
    OrderType: string,
    Type: number,
    Hid: string,
    DepositTypeID: string,
  ): Promise<any[] | null> {
    const storage = JSON.parse(localStorage.getItem("storage")!);
    const tenantId = storage?.tenantID || 0;
    const userName = storage?.userName || "";
    const Role = storage?.rolId || "";

    const response = await Instense.get<any[]>(
      `/DailyActivity/GetDAChartList`,
      {
        params: { OrderType, Role, Type, Hid, DepositTypeID, tenantId, userName },
      }
    );
    return response.data;
  }
}